export const DEFAULT_HIDDEN_COLUMNS = new Set([
  'item-Sizing',
  'casepack-Sizing',
]);

export const HIDDEN_COLUMNS_NAMESPACE = 'Inventory/Linesheet/HiddenColumns';

export const PRODUCTS_TO_FETCH = 40;

export const MAX_ALLOCATIONS_ALLOWED = 10000;
